module.exports = __webpack_public_path__ + "static/media/DonkeyKong.19dc6b80.jpg";